import { Phone, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";

const REGIONS = [
    "Auckland",
    "Wellington",
    "Christchurch",
    "Hamilton",
    "Tauranga",
    "Dunedin",
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-carbon border-t border-white/10 text-slate-100 pt-16 pb-8"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
                    <div className="md:col-span-4">
                        <Logo light />
                        <p className="text-slate-400 mt-4 max-w-md leading-relaxed">
                            AI-powered panel &amp; paint estimates, matched to
                            trusted local repairers across New Zealand.
                            Insurance approved and fairly priced.
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <h4 className="text-xs uppercase tracking-[0.22em] text-slate-500 mb-4">
                            Regions we cover
                        </h4>
                        <div className="grid grid-cols-2 gap-x-6 gap-y-2.5">
                            {REGIONS.map((r) => (
                                <span
                                    key={r}
                                    className="text-slate-300 text-sm hover:text-electric transition-colors cursor-default"
                                >
                                    {r}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className="md:col-span-5">
                        <h4 className="text-xs uppercase tracking-[0.22em] text-slate-500 mb-4">
                            Contact
                        </h4>
                        <p className="flex items-center gap-3 text-slate-300 mb-2.5">
                            <Phone size={18} strokeWidth={1.5} className="text-electric" />
                            <a
                                href="tel:+64211843157"
                                className="hover:text-electric transition-colors"
                            >
                                021 184 3157
                            </a>
                        </p>
                        <p className="flex items-center gap-3 text-slate-300">
                            <Mail size={18} strokeWidth={1.5} className="text-electric" />
                            <a
                                href="mailto:contact@panelpros.co.nz"
                                className="hover:text-electric transition-colors break-all"
                            >
                                contact@panelpros.co.nz
                            </a>
                        </p>
                    </div>
                </div>
                <p className="text-xs text-slate-500 mt-6 max-w-3xl leading-relaxed">
                    All prices shown are indicative NZD estimates and exclude
                    GST. Estimates assume standard paint finishes and ordinary
                    passenger vehicles; your matched repairer confirms the exact
                    price after inspection.
                </p>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mt-5 text-xs text-slate-500">
                    <span>
                        © {new Date().getFullYear()} Panel Pros. All rights
                        reserved.
                    </span>
                    <a
                        href="/shops"
                        data-testid="footer-shops-link"
                        className="hover:text-electric transition-colors"
                    >
                        Panel shop login
                    </a>
                    <a
                        href="/admin"
                        data-testid="footer-admin-link"
                        className="hover:text-electric transition-colors"
                    >
                        Admin
                    </a>
                </div>
            </div>
        </footer>
    );
}
